import React from "react";
import { ArrowUpRightIcon } from "lucide-react";
import type { IconComponent } from "../../types/ui";
type Accent = 'navy' | 'azure' | 'deep' | 'flame';
interface KpiTileProps {
  label: string;
  value: number | string;
  note: string;
  icon: IconComponent;
  accent: Accent;
  onClick?: () => void;
}
const ACCENTS: Record<Accent, string> = {
  navy: 'bg-navy/[0.06] text-navy',
  azure: 'bg-azure/10 text-azure',
  deep: 'bg-deep/10 text-deep',
  flame: 'bg-flame/10 text-flame'
};
export function KpiTile({
  label,
  value,
  note,
  icon: Icon,
  accent,
  onClick
}: KpiTileProps) {
  const content = <>
      <div className="flex items-start justify-between" data-id="element-54" data-mp="2h4wnxl0ze6np">
        <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${ACCENTS[accent]}`} data-id="element-55" data-mp="2l5ffddyypapd">
          <Icon className="h-5 w-5" aria-hidden="true" data-id="element-56" data-mp="2q4jltwui4uc0" />
        </span>
        {onClick && <ArrowUpRightIcon className="h-4 w-4 text-slate-300 transition group-hover:text-flame" aria-hidden="true" data-id="element-57" data-mp="2q2p1okr2168z" />}
      </div>
      <p className="mt-5 text-[32px] font-semibold leading-none tracking-tight text-navy" data-id="element-58" data-mp="etj6fs8d3my8">{value}</p>
      <p className="mt-2 text-sm font-medium text-slate-700" data-id="element-59" data-mp="9tf210kqaiod">{label}</p>
      <p className="mt-0.5 text-xs text-muted" data-id="element-60" data-mp="9w9kimk6ltf5">{note}</p>
    </>;
  const base = 'group rounded-2xl bg-white p-5 text-left shadow-soft ring-1 ring-slate-900/[0.04]';
  if (onClick) {
    return <button type="button" onClick={onClick} className={`${base} transition hover:-translate-y-0.5 hover:shadow-lift`} data-id="element-61" data-mp="vbgw5dnnnx3">
        {content}
      </button>;
  }
  return <div className={base} data-id="element-62" data-mp="tiyydbjmpyfi">{content}</div>;
}